import { Sparkles } from 'lucide-react';

/**
 * Transient in-flight chip shown while an Ask translation runs: rotating
 * gradient ring, pulsing sparkle, ticking ellipsis (see globals.css
 * `.ask-chip*`). Never editable or persisted — on success the parent replaces
 * it with ordinary filter chips.
 */
export function AskChip({ question }: { question: string }) {
  return (
    <output className="ask-chip inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1 text-xs text-brand">
      <Sparkles className="ask-chip-sparkle h-3.5 w-3.5" aria-hidden />
      <span className="max-w-[240px] truncate">{question}</span>
      <span className="ask-chip-dots" aria-hidden />
      <span className="sr-only">Translating question…</span>
    </output>
  );
}
